import { coursesAdapter } from "./slice";
import type { RootState } from "../index";

const base = (state: RootState) => state.courses;
export const { selectAll: selectCourses, selectById: selectCourseById, selectIds: selectCourseIds } =
    coursesAdapter.getSelectors(base);

export const selectCoursesLoading = (state: RootState) => state.courses.loading;
export const selectCourseError = (state: RootState) => state.courses.error;